export const getGroupKeys = (groups) => {
    let groupKeys = Object.keys(groups);
    groupKeys.sort(PULSE.app.common.match.sortGroupKeys);

    // merge TBC/cancelled/postponed into a single group;
    // the previous "groupBy" will ensure that the matches are added in the correct sort order here
    const groupedTBCMatches = groupKeys.reduce((grouped, groupKey) => {
        if (PULSE.app.common.match.cancelledOrPostponed(groupKey)) {
            return [...grouped, ...groups[groupKey]];
        }
        return grouped;
    }, []);

    if (groupedTBCMatches.length > 0) {
        // remove the individual TBC groups, we want them under one banner
        for (let groupKey in groups) {
            if (PULSE.app.common.match.cancelledOrPostponed(groupKey)) {
                delete groups[groupKey];
            }
        }

        groupKeys = Object.keys(groups);
        groupKeys.sort(PULSE.app.common.match.sortGroupKeys);

        groups[PULSE.app.common.CONSTANTS.UNCONFIRMED_GROUP] =
            groupedTBCMatches;
        groupKeys = [
            ...groupKeys,
            PULSE.app.common.CONSTANTS.UNCONFIRMED_GROUP
        ];
    }

    return groupKeys;
};
